const attributionKeys = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "fbclid",
  "msclkid",
] as const;

export type AttributionKey = (typeof attributionKeys)[number];
export type AttributionValues = Partial<Record<AttributionKey, string>>;

const storagePrefix = "setin_attribution_";

function getSessionStorage(): Storage | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function captureAttributionFromUrl(search = typeof window !== "undefined" ? window.location.search : "") {
  const storage = getSessionStorage();
  if (!storage || !search) {
    return {};
  }

  const params = new URLSearchParams(search);
  const captured: AttributionValues = {};

  attributionKeys.forEach((key) => {
    const value = params.get(key);
    if (!value) {
      return;
    }

    captured[key] = value;
    storage.setItem(`${storagePrefix}${key}`, value);
  });

  return captured;
}

export function getStoredAttribution(): AttributionValues {
  const storage = getSessionStorage();
  if (!storage) {
    return {};
  }

  return attributionKeys.reduce<AttributionValues>((values, key) => {
    const value = storage.getItem(`${storagePrefix}${key}`);
    if (value) {
      values[key] = value;
    }
    return values;
  }, {});
}

export function clearStoredAttributionForTests() {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  attributionKeys.forEach((key) => storage.removeItem(`${storagePrefix}${key}`));
}
